import { Dictionary, forEach, isEmpty, isNull, isNil } from 'lodash';
import { Nullable, omitDeepUndefined } from '../../utils';

type TeacherEntryPinUpdateData = {
  pinId: string;
  words: { [word: string]: { x: number; y: number; hidden?: boolean } };
};

type TeacherEntryUpdateFields = {
  removeAllPinEntries?: boolean;
  removeEntriesPinIds?: string[];
  pinEntries?: TeacherEntryPinUpdateData[];
};

export type TeacherEntryUpdateData = Nullable<TeacherEntryUpdateFields>;

export namespace TeacherEntryUpdateData {
  export function updateFields(data: TeacherEntryUpdateData): object {
    const fields: Dictionary<any> = {};
    const now = Date.now();

    forEach(data.pinEntries, (pinEntry) => {
      const pinId = pinEntry.pinId;
      fields[`entries.${pinId}.pinId`] = pinEntry.pinId;

      // todo: apply words array
      updateProperty(fields, `entries.${pinId}.words`, pinEntry.words);
    });

    if (data.removeAllPinEntries) {
      fields[`entries`] = {};
    }
    forEach(data.removeEntriesPinIds, (pinId) => (fields[`entries.${pinId}`] = null));

    const cleaned = omitDeepUndefined(fields);

    if (!isEmpty(cleaned)) {
      cleaned['modifiedAt'] = now;
    }
    return cleaned;
  }
}

/** helper for setting the property, when the value is null. it will delete the field */
function updateProperty(updateFields: Dictionary<any>, field: string, value: any | null | undefined) {
  if (isNull(value)) {
    updateFields[field] = null;
  } else if (!isNil(value)) {
    updateFields[field] = value;
  }
}
